export class LinkBinding {
  /** The href to navigate to when the link is clicked. */
  public href = "@";

  /** True if the link should have button styling, false otherwise. This is evaluated at initialization time only. */
  public isButton = "<?";

  /** The target for the click action, fills the target HTML attribute. */
  public target = "@";

    /** The text's title that's read by screen reader to the content of the link. */
    public title = "@";

    /** The text that appears in the content of the link. Note: while this component doesn't currently support transclusion, when transclusion is added this text will be used for accessibility purposes.*/
    public text = "@";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";

  public telemetryData = "<?";

  public scenario = "@?";

  public scenarioStep = "@?";
}

const buttonClass = "c-button";
const linkClass = "c-hyperlink";
const defaultRole = "link";

class LinkController {
    public href: string;
    public isButton: boolean;
    public target: string;
    public title: string;
    public text: string;
    public biId: string;

  public linkClass: string = linkClass;
  public role: string = defaultRole;

  private telemetryData: any;
  private scenario: string;
  private scenarioStep: string;

  $onInit() {
    if (this.isButton) {
      this.linkClass = buttonClass;
      this.role = "button";
    }
  }
}

export const sdLink: ng.IComponentOptions = {
  bindings: <any>new LinkBinding(),
  controller: LinkController,
  templateUrl: "../ShellCommon/Controls/Link/Link.html",
  transclude: true
};
